import { Component, OnInit, ElementRef } from '@angular/core';
import { SpecialtiesService } from '../services/specialties/specialties.service';
import { LocalesService } from '../services/locales/locales.service';
import { Auth } from '../services/auth.service';


interface FileReaderEventTarget extends EventTarget {
    result:string
  }

  interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage():string;
  }
@Component({
    selector: 'specialties',
    templateUrl: './specialties.component.html',
    styleUrls: ['../users/users.component.css']
})

export class SpecialtiesComponent implements OnInit{

    locales: any[];
    newSpecialtyNames:any = {};
    newSpecialtyDegrees:any = {};
    newSpecialtyColor: String;
    newSpecialtyImage: String;
    newSpecialtyImageIcon: String;
    newIcon: String;
    alertMessage: String = "";
    alertAdd: boolean = false;
    alertCreated: boolean = false;

    formData:any=new FormData()

    specialties: any=[];

    hasSysOpsPermission:boolean = false;

    constructor(protected specialtiesService: SpecialtiesService,
        protected localesService: LocalesService,
        protected auth: Auth){

    }

    protected getDetailUrl(specialty): string {
        return '/specialty/' + specialty.realId;
    };

    async ngOnInit(){
        this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
        this.locales = await this.localesService.getAll();
        this.specialties = await this.specialtiesService.getAll()
    };

    async onSelect(specialty){
        window.open(window.location.origin + this.getDetailUrl(specialty));
        return;
    };

    async add(){
        this.alertCreated = false;
        this.alertAdd = false;
        for (const locale of this.locales){
            if(!this.newSpecialtyNames[locale] || !this.newSpecialtyNames[locale].trim()){
                this.alertAdd = true;
                this.alertMessage = `Missing required specialty name for language ${locale}`;
                return;
            }

            if(!this.newSpecialtyDegrees[locale] || !this.newSpecialtyDegrees[locale].trim()){
                this.alertAdd = true;
                this.alertMessage = `Missing required specialty degree for language ${locale}`;
                return;
            }
        }

        if(!this.newSpecialtyColor){
            this.alertAdd = true;
            this.alertMessage = `Missing required field 'hexaColor'`
            return;
        }

        try{
            await this.specialtiesService.createSpecialty(this.newSpecialtyNames, this.newSpecialtyDegrees, this.newSpecialtyColor).then(specialty =>{
              return this.specialtiesService.editImages(specialty.id, this.formData).then(() =>{
                this.alertAdd = false;
                this.alertCreated = true;
                window.location.reload();
              })
            })
        }
        catch(e){
            this.alertAdd = true;
            this.alertMessage = `There was an unexpected error.`
            return;
        }
    }

    changeImage($ev:any){
      var inputValue = $ev.target;
      let file = inputValue.files[0];
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          const img = new Image();
          img.src = window.URL.createObjectURL(file);
          img.onload = () => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            window.URL.revokeObjectURL(img.src);
            if ((width >= 660 && width <= 690) && (height >= 170 && height <= 180)){
              this.formData.set("image",  file);
              this.readImage($ev);
            } else {
              alert("ERROR. El tamaño de la imagen debe ser de 675x175 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
           }
          }
        }
      }
    }

    readImage(event) {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (event:FileReaderEvent) => {
          this.newSpecialtyImage = event.target.result;
        }
        reader.readAsDataURL(event.target.files[0]);
      }
    }

    changeImageIcon($ev:any){
        var inputValue = $ev.target;
        let file = inputValue.files[0];
        let reader = new FileReader();
        if (file) {
          reader.readAsDataURL(file);
          reader.onload = () => {
            const img = new Image();
            img.src = window.URL.createObjectURL(file);
            img.onload = () => {
              const width = img.naturalWidth;
              const height = img.naturalHeight;
              window.URL.revokeObjectURL(img.src);
              if ((width >= 290 && width <= 310) && (height >= 290 && height <= 310)){
                this.formData.set("imageIcon",  file);
                this.readImageIcon($ev);
              } else {
                alert("ERROR. El tamaño de la imagen debe ser de 300x300 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
             }
            }
          }
        }
    }

    readImageIcon(event) {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (event:FileReaderEvent) => {
          this.newSpecialtyImageIcon = event.target.result;
        }
        reader.readAsDataURL(event.target.files[0]);
      }
    }

    changeIcon($ev:any){
      var inputValue = $ev.target;
      let file = inputValue.files[0];
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          const img = new Image();
          img.src = window.URL.createObjectURL(file);
          img.onload = () => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            window.URL.revokeObjectURL(img.src);
            if (width == 288 || width == 288){
              this.formData.set("icon",  file);
              this.readIcon($ev);
            } else {
              alert("ERROR. El tamaño de la imagen debe ser de 288x288 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
           }
          }
        }
      }
    }

    readIcon(event) {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (event:FileReaderEvent) => {
          this.newIcon = event.target.result;
        }
        reader.readAsDataURL(event.target.files[0]);
      }
    }

    setMedikitIDs(evt: any) {
      let inputValue = evt.target;
      let file = inputValue.files[0];
      let formData = new FormData();
      inputValue.value = '';

      formData.append("medikitCatalogue", file);


      return this.specialtiesService.setMedikitIDs(formData).then(() => {
        alert("OK");
      })
      .catch((err)=>{

        return err && err._body ?
              (err._body.message ? alert(err._body.message) : alert(err))
              : alert(err);
      })
    }
}



// WEBPACK FOOTER //
// ./src/app/specialties/specialties.component.ts